<template>
	<ClientOnly>
		<HomeView />
	</ClientOnly>
</template>

<script setup lang="ts">
	import { definePageMeta } from '#imports'

	definePageMeta({ middleware: ['auth', 'has-to-complete-profile'] })
</script>
